import { Injectable, Inject } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class RegraFreteService {
  public URL = environment.angularJSconstants.URLAPI;

  constructor(private http: HttpClient) {}

  public async getToken(): Promise<any> {
    try {
      const url = `${environment.angularJSconstants.URLAPICLIENTE}/api`;

      return await this.http.get(url).toPromise();
    } catch (error) {
      throw error;
    }
  }

  public async criarRegra(payload): Promise<any> {
    try {
      const url = `${this.URL}/regraFrete`;

      return await this.http.post(url, payload).toPromise();
    } catch (error) {
      throw error;
    }
  }

  public async listarRegras(): Promise<any> {
    try {
      const url = `${this.URL}/regraFrete?q=${new Date().toISOString()}`;

      return await this.http.get(url).toPromise();
    } catch (error) {
      throw error;
    }
  }

  public async novaOrdem(ordem): Promise<any> {
    try {
      const url = `${this.URL}/regraFrete/ordem`;

      return await this.http.post(url, ordem).toPromise();
    } catch (error) {
      throw error;
    }
  }

  public listaEstados(): any[] {
    return [
      { nome: "Acre", sigla: "AC" },
      { nome: "Alagoas", sigla: "AL" },
      { nome: "Amapá", sigla: "AP" },
      { nome: "Amazonas", sigla: "AM" },
      { nome: "Bahia", sigla: "BA" },
      { nome: "Ceará", sigla: "CE" },
      { nome: "Distrito Federal", sigla: "DF" },
      { nome: "Espírito Santo", sigla: "ES" },
      { nome: "Goiás", sigla: "GO" },
      { nome: "Maranhão", sigla: "MA" },
      { nome: "Mato Grosso", sigla: "MT" },
      { nome: "Mato Grosso do Sul", sigla: "MS" },
      { nome: "Minas Gerais", sigla: "MG" },
      { nome: "Pará", sigla: "PA" },
      { nome: "Paraíba", sigla: "PB" },
      { nome: "Paraná", sigla: "PR" },
      { nome: "Pernambuco", sigla: "PE" },
      { nome: "Piauí", sigla: "PI" },
      { nome: "Rio de Janeiro", sigla: "RJ" },
      { nome: "Rio Grande do Norte", sigla: "RN" },
      { nome: "Rio Grande do Sul", sigla: "RS" },
      { nome: "Rondônia", sigla: "RO" },
      { nome: "Roraima", sigla: "RR" },
      { nome: "Santa Catarina", sigla: "SC" },
      { nome: "São Paulo", sigla: "SP" },
      { nome: "Sergipe", sigla: "SE" },
      { nome: "Tocantins", sigla: "TO" },
    ];
  }
}
